import { graphql } from "gql";

const INTERNAL_ADMIN_CREATE_DISTRIBUTION_GROUP_MUTATION = graphql(`
  mutation InternalAdminCreateDistributionGroup(
    $organizationId: ID!
    $input: AdminCreateDistributionGroupInput!
  ) {
    internalAdminCreateDistributionGroup(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminDistributionGroup
    }
  }
`);

export default INTERNAL_ADMIN_CREATE_DISTRIBUTION_GROUP_MUTATION;
